import { FilmFilterKey, getAttributeById, getEventById, getGenreById, getSubscriptionById, ShowtimeFilterKey, SubscriptionBillingRecurrence, SubscriptionFilterKey } from '@vista/omnichannel-components-domain';
import { FilmCategory, SubscriptionBillingPeriod } from '@vista-digital/ocapi-types/v1';
import { allFilterOptionValue } from './constants';
export const getFilterLabel = (filterKey, value, config, displayText, i18n, allOptionLabel) => {
    if (value === allFilterOptionValue)
        return allOptionLabel || displayText.filter.allOptionLabel;
    switch (filterKey) {
        case FilmFilterKey.Genre:
        case ShowtimeFilterKey.Genre:
            return getLabelForGenre(value, i18n);
        case FilmFilterKey.Attribute:
        case ShowtimeFilterKey.Attribute:
            return getLabelForAttribute(value, config, i18n);
        case FilmFilterKey.Event:
        case ShowtimeFilterKey.Event:
            return getLabelForEvent(value, i18n);
        case FilmFilterKey.Category:
            return getLabelForFilmCategory(value, displayText);
        case SubscriptionFilterKey.Subscription:
            return getLabelForSubscription(value, i18n);
        case SubscriptionFilterKey.BillingPeriod:
            return getLabelForBillingPeriod(value, displayText, i18n);
        case SubscriptionFilterKey.BillingRecurrence:
            return getLabelForBillingRecurrence(value, displayText);
        default:
            throw new Error(`Cannot get filter label for '${value}'.`);
    }
};
const getLabelForGenre = (id, i18n) => {
    const genre = getGenreById(id);
    if (!genre)
        throw new Error(`Cannot get filter label for genre with ID: '${id}'.`);
    return i18n.translatable(genre.name);
};
const getLabelForAttribute = (id, config, i18n) => {
    const attribute = getAttributeById(id);
    if (!attribute)
        throw new Error(`Cannot get filter label for attribute with ID: '${id}'.`);
    return i18n.translatable(config.filter.showFullAttributeName ? attribute.name : attribute.shortName);
};
const getLabelForEvent = (id, i18n) => {
    const event = getEventById(id);
    if (!event)
        throw new Error(`Cannot get filter label for event with ID: '${id}'.`);
    return i18n.translatable(event.name);
};
const getLabelForFilmCategory = (category, displayText) => {
    switch (category) {
        case FilmCategory.NowShowing:
            return displayText.film.nowShowingLabel;
        case FilmCategory.ComingSoon:
            return displayText.film.comingSoonLabel;
        case FilmCategory.AdvanceBooking:
            return displayText.film.advanceBookingLabel;
        default:
            throw new Error(`Cannot get filter label for unknown FilmCategory '${category}'.`);
    }
};
const getLabelForSubscription = (id, i18n) => {
    const subscription = getSubscriptionById(id);
    if (!subscription)
        throw new Error(`Cannot get filter label for subscription with ID: '${id}'.`);
    return i18n.translatable(subscription.name);
};
const getLabelForBillingPeriod = (billingPeriodInMonths, displayText, i18n) => {
    const templateString = billingPeriodInMonths === SubscriptionBillingPeriod.OneMonth
        ? displayText.filter.oneMonthSubscriptionBillingPeriodLabel
        : displayText.filter.subscriptionBillingPeriodLabel;
    return i18n.template(templateString, { billingPeriodInMonths });
};
const getLabelForBillingRecurrence = (billingRecurrence, displayText) => {
    switch (billingRecurrence) {
        case SubscriptionBillingRecurrence.Recurring:
            return displayText.filter.recurringSubscriptionBillingPeriodLabel;
        case SubscriptionBillingRecurrence.NonRecurring:
        default:
            return displayText.filter.nonRecurringSubscriptionBillingPeriodLabel;
    }
};
